// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  margin: var(--content-margin);
}

.header {
  margin-top: 3px;
  margin-bottom: 20px;
}

table {
  width: 100%;
}

.compact {
  height: 38px !important;
}

.compact mat-cell,
.compact mat-cell-header {
  font-size: 10pt;
}

.redButton {
  min-width: 100px;
}

.spacer {
  flex: 1 1 auto;
}

#asset-container {
  position: relative;
  margin-top: 30px;
}

#lock-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.subheader {
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: 16px;
}

.btn {
  display: flex;
  gap: var(--content-gutter);
  justify-content: flex-end;
  margin-top: var(--content-margin);
  margin-bottom: 40px;
}
.btn button mat-icon {
  margin-right: 8px;
}

.warning {
  width: 95%;
  height: 25px;
  margin-top: 15px;
  padding: 20px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 16px;
}

.inline-icon {
  vertical-align: bottom;
  margin-right: 5px;
  font-size: 28px !important;
}

#recent-build-container {
  position: relative;
}

#recent-build-label {
  position: absolute;
  left: 0;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  padding: 8px 0 0 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.125;
  letter-spacing: normal;
  pointer-events: none;
}

#recent-build-container button {
  display: inline-flex;
  align-items: flex-end;
  min-width: 75px;
  height: 60px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

tr {
  cursor: pointer;
}

#loading-tool {
  margin-bottom: 20px;
  font-size: 1.3em;
}

.padded {
  padding: 20px;
}

.clickable {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/asset/asset.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;;EAEE,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,0BAAA;EACA,yBAAA;EACA,iCAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,sBAAA;EACA,iBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,eAAA;AAAF","sourcesContent":[".container {\n  margin: var(--content-margin);\n}\n\n.header {\n  margin-top: 3px;\n  margin-bottom: 20px;\n}\n\ntable {\n  width: 100%;\n}\n\n.compact {\n  height: 38px !important;\n}\n\n.compact mat-cell,\n.compact mat-cell-header {\n  font-size: 10pt;\n}\n\n.redButton {\n  min-width: 100px;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n#asset-container {\n  position: relative;\n  margin-top: 30px;\n}\n\n#lock-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 10;\n}\n\n.subheader {\n  margin-top: 15px;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n\n.btn {\n  display: flex;\n  gap: var(--content-gutter);\n  justify-content: flex-end;\n  margin-top: var(--content-margin);\n  margin-bottom: 40px;\n\n  & button mat-icon {\n    margin-right: 8px;\n  }\n}\n\n.warning {\n  width: 95%;\n  height: 25px;\n  margin-top: 15px;\n  padding: 20px;\n  border-radius: 10px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.inline-icon {\n  vertical-align: bottom;\n  margin-right: 5px;\n  font-size: 28px !important;\n}\n\n#recent-build-container {\n  position: relative;\n}\n\n#recent-build-label {\n  position: absolute;\n  left: 0;\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  padding: 8px 0 0 8px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.125;\n  letter-spacing: normal;\n  pointer-events: none;\n}\n\n#recent-build-container button {\n  display: inline-flex;\n  align-items: flex-end;\n  min-width: 75px;\n  height: 60px;\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n}\n\ntr {\n  cursor: pointer;\n}\n\n#loading-tool {\n  margin-bottom: 20px;\n  font-size: 1.3em;\n}\n\n.padded {\n  padding: 20px;\n}\n\n.clickable {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
